const accordion = (): void => {
  const accordions = document.querySelectorAll('.accordion-block')

  accordions.forEach((accordion) => {
    accordion.querySelectorAll('.accordion-btn').forEach((btn) => {
      btn?.addEventListener('click', () => {
        const btnArrow = btn.querySelector('.accordion-arrow')
        const btnExpanded = btn.getAttribute('aria-expanded')
        const btnState = btn.getAttribute('aria-pressed')
        const content = btn.nextElementSibling

        btnArrow?.classList.toggle('rotate')
        btnExpanded === 'true'
          ? btn.setAttribute('aria-expanded', 'false')
          : btn.setAttribute('aria-expanded', 'true')
        btnState === 'true'
          ? btn.setAttribute('aria-pressed', 'false')
          : btn.setAttribute('aria-pressed', 'true')
        content?.classList.toggle('open')
      })
    })
  })
}

export default accordion
